exports.default = "<div class=\"slide\">${model.content}</div>";